export default __webpack_public_path__ + "static/media/drinkoFarmImageThree.f1c3db59.png";